module.exports = __webpack_public_path__ + "static/media/noCustomerVector.ca955086.png";